import clsx from "clsx";
import { Button } from "src/components/Button/Button";
import type { Merge } from "src/models/utility";
import { useDropdownContext } from "../root/Dropdown.root";
import styling from "./Dropdown.item.module.scss";

export namespace DropdownItem {
	export type ElementName = "button";
	export type ElementType = HTMLButtonElement;
	export type Props = Merge<
		Button.Props,
		{
			value?: any;
			onSelectItem?: (item: Props) => void;
		}
	>;
}

export const DropdownItem = (props: DropdownItem.Props) => {
	const { className, children, state, onSelectItem, onClick, ...rest } = props;
	const { closeMenu, open } = useDropdownContext();

	return (
		<Button
			role="menuitem"
			type="button"
			className={clsx(styling.item, {
				[styling["item--open"]]: open,
				[`${className}`]: className,
			})}
			state={state}
			onClick={(e) => {
				onClick?.(e);
				onSelectItem?.(props);
				if (!(e.currentTarget?.dataset?.dropdownClose === "false")) {
					closeMenu();
				}
			}}
			{...rest}
		>
			{children}
		</Button>
	);
};
